import { Cache } from "memory-cache";
import { StaticStorageClient } from "../service/staticstorageclient";
import { SchematicEntity } from ".";

// ESI client
const dataClient = new StaticStorageClient();

// Cache
const cache = new Cache();

export async function getCachedSchematicEntity(
  schematic_id_or_output_type_id: number
): Promise<SchematicEntity | null> {
  let entity: any = await cache.get(schematic_id_or_output_type_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const schematic = await dataClient.get_schematics_info_by_id(schematic_id_or_output_type_id);
    const schematic_pin_info = await dataClient.get_schematics_pin_info_by_id(schematic_id_or_output_type_id);
    if (schematic.length && schematic_pin_info.length) {
      entity = new SchematicEntity(schematic_id_or_output_type_id, schematic, schematic_pin_info);
      cache.put(schematic_id_or_output_type_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      const schematic_fallback = await dataClient.get_schematic_by_output_id(schematic_id_or_output_type_id);
      if (schematic_fallback !== null) {
        const fallback_id = schematic_fallback.schematicID;
        let entity: any = await cache.get(fallback_id.toString());
        if (entity) {
          return entity;
        }
        const schematic = await dataClient.get_schematics_info_by_id(fallback_id);
        const schematic_pin_info = await dataClient.get_schematics_pin_info_by_id(fallback_id);
        if (schematic.length && schematic_pin_info.length) {
          entity = new SchematicEntity(fallback_id, schematic, schematic_pin_info);
          cache.put(fallback_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
          return entity;
        } else return null;
      } else return null;
    }
  } catch (error: any) {
    console.error(error);
    return null;
  }
}
